<template>
  <div id="monitor">
    <!-- {{PlugJson}} -->
    <van-tag type="primary" @click="showPopup">{{'监考老师 ' + PlugJson.PlugBody.MonitorNum + ' 人'}}</van-tag>
    <van-popup
      v-model="monitorList"
      position="bottom"
      round
      closeable
      class="popup-l1"
      get-container="#app"
    >
      <van-nav-bar :title="'监考老师 ' + PlugJson.PlugBody.MonitorNum + ' 人'" left-text="列表" />
      <div class="mt-4 p-4">
        <van-cell v-for="(item,index) in PlugJson.PlugBody.MonitorList" :key="index">
          <template slot="title">{{item.RoomNo || '流动'}}:{{item.Name}}</template>
          <template slot="default">
            <a class="color-blue" :href="'tel:' + item.Tel">
              {{
              item.Tel
              }}
            </a>
          </template>
          <template slot="label">身份证号:{{item.UserPIN}}</template>
        </van-cell>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "monitor",
  props: {
    PlugJson: Object
  },
  data() {
    return {
      monitorList: false
    };
  },
  methods: {
    showPopup() {
      this.monitorList = true;
    }
  }
};
</script>

<style scoped>
</style>